import * as yup from 'yup';

export const schemaFeriado = yup.object().shape({
  IdEmpresa: yup.number('').required('ID da empresa é obrigatório'),
  Descricao: yup.string().required('Descrição é obrigatória'),
  Dia: yup
    .number()
    .required('Dia é obrigatório')
    .min(1, 'Dia inválido')
    .max(31, 'Dia inválido'),
  Mes: yup
    .number()
    .required('Mês é obrigatório')
    .min(1, 'Mês inválido')
    .max(12, 'Mês inválido'),
});
